<template>
  <Layout is-demo>
    <div class="">
      <h1 class="text-h4 pd-3">Initialize Licenses</h1>
    </div>
    <v-divider class="my-2"></v-divider>
    
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
        Uninitialized Licenses
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="tableData"
            sort-by="postDate,credit,debit"
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            fixed-header
            height="350px"
            :search="search"
            group-by="lOB"
            :no-data-text="tableNoDataText"
            show-group-by
          >
            <template v-slot:item.actions="{ item }">
              <v-btn 
                v-if="rowStatus(item)==='none'"
                class="mx-1"
                outlined
                color="green"
                @click="getDetails(item)"
              >
                Appraise Details
              </v-btn>
              <v-btn 
                v-if="rowStatus(item)==='state'"
                class="mx-1"
                outlined
                color="teal"
                @click="showOtherDialog(item)"
              >
                Assign Number
              </v-btn>
              <v-btn 
                v-if="rowStatus(item)==='license'"
                class="mx-1"
                outlined
                color="cyan"
                @click="makePrintable(item)"
              >
                Make Printable
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="detailsDialog"
      width="950"
    >
      <v-card>
        <v-card-title class="text-h5 white--text green lighten-2">
          Company Details Appraisal
        </v-card-title>
        <v-card-text class="my-0 pa-1">
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="4" class="pa-0 ma-1">
              <v-textarea
                v-model="company"
                label="Company"
                counter
                maxlength="120"
                full-width
                auto-grow
                rows="2"
                disabled
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="1" class="pa-0 ma-1">
              <v-btn
                color="primary"
                class="my-2 px-1"
                outlined
                text
                @click="copyValue('company')"
              >
                Copy >>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" class="pa-0 ma-1">
              <v-textarea
                v-model="company_edited"
                label="Company Edited*"
                counter
                maxlength="100"
                full-width
                rows="2"
                hide-details="auto"
                auto-grow
                :error-messages="companyError"
                :error-count="companyErrorCount"
                @input="companyChange"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="2" class="pa-0 ma-1">
              <v-btn
                color="primary"
                class="my-2 px-1"
                text
                outlined
                @click="autoFormat('company')"
              >
                Auto Format
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" class="pa-0 ma-0 d-flex justify-center">
              <v-divider 
                color="green" 
                width="60%"
              >
              </v-divider>
            </v-col>

            <v-col cols="12" sm="4" class="pa-0 ma-1">
              <v-textarea
                v-model="address"
                label="Address"
                counter
                maxlength="200"
                full-width
                auto-grow
                rows="4"
                disabled
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="1" class="pa-0 ma-1">
              <v-btn
                color="primary"
                class="my-2 px-1"
                text
                @click="copyValue('address')"
              >
                Copy >>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" class="pa-0 ma-1">
              <v-textarea
                v-model="address_edited"
                label="Address Edited*"
                counter
                maxlength="150"
                full-width
                rows="4"
                hide-details="auto"
                auto-grow
                :error-messages="addressError"
                :error-count="addressErrorCount"
                @input="addressChange"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="2" class="pa-0 ma-1">
              <v-btn
                v-if="commonAddressError.length > 0"
                color="primary"
                class="my-0 px-1"
                text
                @click="showError"
              >
                Show error phrase(s)
              </v-btn>
              <v-btn
                color="primary"
                class="my-0 px-1"
                text
                outlined
                @click="autoFormat('address')"
              >
                Auto Format
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" class="pa-0 ma-0 d-flex justify-center">
              <v-divider 
                color="green" 
                width="60%"
              >
              </v-divider>
            </v-col>

            <v-col cols="12" sm="4" class="pa-0 ma-0">
              <v-text-field
                v-model="state"
                label="State"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="1" class="pa-0 ma-1">
              <v-btn
                color="primary"
                class="my-2 px-1"
                text
                @click="copyValue('state')"
              >
                Copy >>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" class="pa-0 ma-0">
              <v-text-field
                v-model="state_edited"
                label="State*"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-col cols="12" sm="12" class="pa-0 ma-0">
          <v-divider></v-divider>
        </v-col>

        <v-card-actions color="grey">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="approveDetails"
          >
            Approve Details
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="closeDetailsDialog"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 white--text green lighten-2">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text class="my-2">
          {{ dialogMessage }}
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assignNumber()"
          >
            Continue
          </v-btn>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card-actions></v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
import httpServ from '../services/HTTPService'

export default {
  components: {
    Layout
  },
  data() {
    return {
      search: '',
      memberData: {},
      currentLOBDetails: {},
      prePostData: {},
      pageData: {},
      tableLoading: true,
      singleSelect: true,
      tableNoDataText: 'Thus table has no record!',
      credit:0,
      balance:0,
      debit:0,

      snackbar: false,
      snackbartext: '',
      detailsDialog: false,
      dialog: false,
      dialogMessage: '',
      dialogTitle: '',
      tableItem: [],
      currentItem:[],
      overlay: false,

      company:'',
      company_length :100,
      company_edited: '',
      companyError: [],
      companyErrorCount:0,
      address:'',
      address_length: 150,
      address_edited: '',
      addressError: [],
      addressErrorCount:0,
      state:'',
      state_edited: '',
      certificateData: {},
      commonAddressError: [],

      headers: [
        { text: 'Certificate #.', value: 'certificate_number' },
        { text: 'Company', value: 'company_name' },
        { text: 'Line Of Business', value: 'lOB' },
        { text: 'Dis. Cat.', value: 'distributor_category' },
        { text: 'State', value: 'operational_state' },
        { text: 'Attribute', value: 'ranking' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      tableData: [],
      common_company_phrases:[
        'nig.ltd',
        'co.ltd',
        'nig',
        'ng',
        'ltd',
        'intl',
        'co',
        'com',
        'state'
      ],
      allowed_address_end : [
        'bauchi','enugu','gombe','kaduna','kano','katsina','sokoto'
      ],
      common_address_phrases:[
        'nigeria',
        'africa'
      ] ,
      common_state_phrases:[
        'abia',
        'adamawa',
        'akwa abom',
        'anambra',
        'bauchi',
        'benue', 
        'borno',
        'bayelsa',
        'cross river',
        'delta',
        'ebonyi',
        'edo',
        'ekiti',
        'enugu',
        'fct',
        'gombe',
        'imo',
        'jigawa',
        'kebbi',
        'kaduna',
        'kogi',
        'kano',
        'katsina',
        'kwara',
        'lagos',
        'niger',
        'nasarawa',
        'ondo',
        'ogun',
        'osun',
        'Oyo',
        'plateau',
        'rivers',
        'sokoto',
        'taraba',
        'yobe',
        'zamfara',
        'nigeria',
        'africa',
        'f.c.t'
      ]
    }
  },
  created() {
    this.userData = httpServ.getSessionJson('userData')
    this.getTableData()
  },
  mounted() {},
  methods: {
    getTableData: function () {

      const url = httpServ.getCertificateUrl('/admin/getPrePrintedCertificatesDetails')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        if (result.status === 200) {
          this.tableData = result.data
        }  else {
          this.tableData = []
        }
      })
      this.tableLoading = false
    },
    closeDetailsDialog: function() {
      this.detailsDialog = false
      this.company = ''
      this.address = ''
      this.state = ''
      this.company_edited = ''
      this.address_edited = ''
      this.state_edited = ''

      this.companyError = []
      this.companyErrorCount = 0
      this.addressError = []
      this.addressErrorCount = 0
    },
    getDetails: function(item) {
      const postData = this.prePostData

      postData.id = item.id
      postData.membership_id = item.membership_id
      postData.state = item.operational_state
      postData.lOB = item.lOB
      this.tableItem = item
      
      //const url = httpServ.getMemberUrl('/account/getPrePrintertDeatails')
      const url = httpServ.getSlime4MemberUrl201('/certificates/pre-prints')
    
      const resp = httpServ.postFetchWithJWT(
        url,
        this.prePostData,
        this.userData.jwt
      )

      resp.then((result) => {
        if (result.status === 200) {

          //console.log(result.data)

          this.certificateData  = result.data
          this.company = this.certificateData.company_name
          this.address = this.certificateData.address
          this.state = this.certificateData.state

          this.detailsDialog = true
        } 
      })

    },
    approveDetails: function() {
      const postData = this.prePostData

      if (this.company_edited === '') {
        this.snackbartext = 'Company Edited field is empty'
        this.snackbar = true

        return
      }

      if (this.address_edited === '') {
        this.snackbartext = 'Address Edited field is empty'
        this.snackbar = true

        return
      }

      if (this.state_edited === '') {
        this.snackbartext = 'State Edited field is empty'
        this.snackbar = true

        return
      }

      postData.id = this.tableItem.id
      postData.membership_id = this.tableItem.membership_id
      postData.state = this.state_edited
      postData.company = this.company_edited
      postData.address = this.address_edited
      postData.lOB = this.tableItem.lOB
      postData.ranking = this.tableItem.ranking
      postData.memberAuth =  this.memberData.jwt

      //console.log(postData)
      postData.email = this.certificateData.email
      postData.phone = this.certificateData.phone
      postData.first_name = this.certificateData.first_name
      postData.surname = this.certificateData.surname
      postData.tin = this.certificateData.tin
      postData.date_of_incorporation = this.certificateData.date_of_incorporation 
      postData.rc_number = this.certificateData.rc_number

      if (postData.membership_id !== null) {
        const url = httpServ.getCertificateUrl('/admin/saveLicensesDetails')
        const resp = httpServ.postFetchWithJWT(
          url,
          this.prePostData,
          this.memberData.jwt
        )

        resp.then((result) => {
          if (result.status === 200) {
            this.closeDetailsDialog()
            this.getTableData()
          } 
        })

      }
    },
    makePrintable: function(item) {
      const postData = this.prePostData

      postData.id = item.id
      postData.membership_id = item.membership_id
      /*if (item.lOB === 'Distributor') {
        console.log(item)
      }*/
      
      if (postData.membership_id !== null) {
        const url = httpServ.getCertificateUrl('/admin/makePrintable')
        const resp = httpServ.postFetchWithJWT(
          url,
          this.prePostData,
          this.memberData.jwt
        )

        resp.then((result) => {
          if (result.status === 200) {
            this.closeDetailsDialog()
            this.getTableData()
          } 
        })

      }
      
    },
    copyValue: function(field) {
      switch (field) {
      case 'company':
        this.company_edited = this.companyErrorCheck(this.certificateData.company)
        break

      case 'address':
        this.address_edited = this.addressErrorCheck(this.certificateData.address)
        break

      case 'state':
        if (this.certificateData.state !== 'FCT') {
          this.state_edited = this.certificateData.state + ' State'
        } else {
          this.state_edited = this.certificateData.state
        }
        
      }
    },
    autoFormat: function(field) {
      switch (field) {
      case 'company':
        // eslint-disable-next-line no-case-declarations
        let txt = this.removeSpaces(this.company_edited)

        txt = this.removeTraillingPunctuations(txt)
        txt = this.capitalizeFirstLetter(txt)
        txt = this.capitalizeAbbrWIthFullstop(txt)
        txt = this.commonAbbrToCaps(txt)
        txt = txt.trim()
        this.companyErrorCheck(txt)
        this.company_edited = txt
        break
      case 'address': 
        this.addressError = []
        this.commonAddressError = []
        // eslint-disable-next-line no-case-declarations
        let add = this.removeSpaces(this.address_edited)

        add = this.removeTraillingPunctuations(add)
        add = this.capitalizeAbbrWIthFullstop(add)
        add = this.replaceCommonMistakes(add)
        add = this.removeCommonAddressPhrases(add)
        add = this.removeNotAllowedEnding(add)

        add = add.trim()

        this.addressErrorCheck(add)
        this.address_edited = add
      }
    },
    capitalizeFirstLetter: function(sentence) {
      if (!sentence) {
        return ''
      }
      const words = sentence.toLowerCase().split(' ')
      const capitalizedWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })

      return capitalizedWords.join(' ')
    },
    removeSpaces: function(txt) {
      let str = txt.trimEnd()

      str  = txt.replaceAll('  ', ' ').replaceAll('   ', ' ').replaceAll('    ', ' ').replaceAll('     ', ' ')
      str = str.trim()

      return str.trim().replaceAll('  ', ' ')
    },
    removeTraillingPunctuations: function(str) {
      return str.replace(/[.,!?;:]+$/, '')
    },
    capitalizeAbbrWIthFullstop: function(sentence) {
      if (!sentence) {
        return ''
      }
      const words = sentence.split(' ')
      const capitalizedWords = words.map((word) => {
        if (word.endsWith('.')) {

          return word.toUpperCase()
        } else {
          return word
        }
      })

      return capitalizedWords.join(' ')
    },
    commonAbbrToCaps: function(sentence) {
      if (!sentence) {
        return ''
      }
      const words = sentence.split(' ')
      const capitalizedWords = words.map((word) => {
        const commonAbbr = ['nig','Nig','ltd','Ltd', 'co','Co', 'com','Com', 'ent','Ent', 'intl','Intl']

        if (commonAbbr.includes(word)) {
          return word.toUpperCase() + '.'
        } else {
          return word
        }
      })

      return capitalizedWords.join(' ')
    },
    containsCommonCompanyPhrases: function(sentence) {
      let ret = false

      if (!sentence) {
        return ret
      }
      const words = sentence.split(' ')

      const capitalizedWords = words.map((word) => {
        let lower = ''

        if (word === String(word).toUpperCase()) {
          lower = word
        } else {
          lower = word.toLowerCase()
        }

        if (this.common_company_phrases.includes(lower)) {
          console.log(lower)
          ret =  true
        } 
      })

      return ret
    },
    lastValidCharater: function(txt) {
      const lastChar = txt[txt.length - 1]

      if (lastChar === ' ') {
        return this.lastValidCharater(txt.trim())
      } else {

        return lastChar
      }
    },
    companyChange: function(value) {
      this.companyError = []
      this.companyErrorCheck(value)
    },
    companyErrorCheck: function(txt) {

      this.companyError = []
      const trim = txt.trim()
      const punctuationMarks = ['.', ',', '!', '?', ';', ':', '-', '(', ')', '[', ']', '{', '}', '"', '\'']
      const lastChar = this.lastValidCharater(txt)

      //check for extract spaces
      if (txt.includes('  ')) {
        this.companyError.push('Extra spaces error')
      }

      //check for Leading/trailing spaces
      if (txt !== trim) {
        this.companyError.push('Leading/trailing spaces error')
      }

      //extract puntuations
      if (punctuationMarks.includes(lastChar)) {
        this.companyError.push('Extra puntuation mark error')
      }

      //Long name
      if (txt.length > 10  && !txt.includes(' ')) {
        this.companyError.push('Long name error')
      }

      //common company phrase
      if (this.containsCommonCompanyPhrases(txt)) {
        this.companyError.push('Common company phrases error')
      }

      //common company phrase
      if (txt.length > 100) {
        this.companyError.push('Maximum length error')
      }

      this.companyErrorCount = this.companyError.length

      return txt
    },
    removeNotAllowedEnding: function (sentence) {
      if (!sentence) {
        return ''
      }

      const str = sentence.trim()
      const wordsArray = str.split(' ')
      let lastWord = wordsArray[wordsArray.length - 1].toLowerCase()

      //remove state
      if (lastWord === 'state') {
        sentence = sentence.substring(0, sentence.lastIndexOf(' '))
        const wordsArray = sentence.split(' ')

        lastWord = wordsArray[wordsArray.length - 1].toLowerCase()
      }

      //console.log(sentence)

      //remove common_address_phase
      if (this.common_address_phrases.includes(lastWord)) {
        sentence = sentence.substring(0, sentence.lastIndexOf(' '))

        const wordsArray = sentence.split(' ')

        lastWord = wordsArray[wordsArray.length - 1].toLowerCase()
        if (this.common_address_phrases.includes(lastWord)) {
          if (!this.allowed_address_end.includes(lastWord)) {
            sentence = sentence.substring(0, sentence.lastIndexOf(' '))

            const wordsArray = sentence.split(' ')

            lastWord = wordsArray[wordsArray.length - 1].toLowerCase()
            if (this.common_address_phrases.includes(lastWord)) {
              if (!this.allowed_address_end.includes(lastWord)) {
                sentence = sentence.substring(0, sentence.lastIndexOf(' '))
              }
            }

          }
        }
      }
      //console.log(sentence)

      return sentence
    },
    removeNotAllowedEnding2: function (sentence) {
      if (!sentence) {
        return ''
      }
      const str = sentence.trim()
      const wordsArray = str.split(' ')
      const lastWord = wordsArray[wordsArray.length - 1].toLowerCase()
      
      const capitalizedWords = words.map((word) => {

        if (this.allowed_address_end.includes(word)) {
          return word.toUpperCase() + '.'
        } else {
          return word
        }
      })

      return capitalizedWords.join(' ')
    },
    allowedAddressEnding: function (txt) {
      const str = txt.trim()
      const wordsArray = str.split(' ')
      const lastWord = wordsArray[wordsArray.length - 1].toLowerCase()

      if (this.allowed_address_end.includes(lastWord)) {
        this.addressError.push(lastWord )

        //console.log(lastWord)

        return true
      }

      return false
    },
    addressChange: function(value) {
      //console.log('Change event fired:', value)
      this.addressErrorCheck(value)
    },
    containsCommonAddressPhrases: function(sentence) {
      let ret = false

      if (!sentence) {
        return ret
      }
      const words = sentence.split(' ')

      const capitalizedWords = words.map((word) => {
        let lower = ''
  
        if (word === String(word).toUpperCase()) {
          lower = word.replace(',','').toLowerCase()
        } else {
          lower = word.replace(',','')
        }

        if (this.common_address_phrases.includes(lower)) {
          this.commonAddressError.push(word)

          //console.log(word)
          ret =  true
        } 
      })

      return ret
    },
    removeCommonAddressPhrases: function(sentence) {
      let ret = ''

      if (!sentence) {
        return ret
      }
      const words = sentence.split(' ')

      const capitalizedWords = words.map((word) => {
        let lower = ''
  
        if (word === String(word).toUpperCase()) {
          lower = word.replace(',','').toLowerCase()
        } else {
          lower = word.replace(',','')
        }

        if (this.common_address_phrases.includes(lower)) {
          ret =  word
        } 
      })

      if (ret !== '') {
        sentence = sentence.replace(ret,'')
      }

      return sentence
    },
    containsCommonMistakes(sentence) {
      let ret = false
      const common_mistakes = ['fct, abuja','f.c.t abuja','FCT, Abuja','F.C.T Abuja']

      if (!sentence) {
        return ret
      }

      common_mistakes.forEach((item) => {
        if (sentence.includes(item)) {
          this.commonAddressError.push(item)
          ret = true
        }
      })

      return ret
    },
    replaceCommonMistakes(sentence) {
      const common_mistakes = ['fct, abuja','f,c,t abuja','FCT, Abuja','F.C.T Abuja']

      if (!sentence) {
        return ret
      }

      common_mistakes.forEach((item) => {
        sentence = sentence.replace(item,'Abuja')
      })

      return sentence
    },
    addressErrorCheck: function(txt) {

      this.addressError = []
      this.commonAddressError = []
      const trim = txt.trim()
      const punctuationMarks = ['!', '?', ';', ':', '-', '(', ')', '[', ']', '{', '}', '"', '\'']
      const lastChar = this.lastValidCharater(txt)

      //check for extract spaces
      if (txt.includes('  ')) {
        this.addressError.push('Extra spaces error')
      }

      //check for Leading/trailing spaces
      if (txt !== trim) {
        this.addressError.push('Leading/trailing spaces error')
      }

      //extract puntuations
      if (punctuationMarks.includes(lastChar)) {
        this.addressError.push('Extra puntuation mark error')
      }

      //Long name
      if (txt.length > 10  && !txt.includes(' ')) {
        this.addressError.push('One word address error')
      }

      //common address phrase
      if (this.containsCommonAddressPhrases(txt)) {
        this.addressError.push('Common address phrases error')
      }

      //common mistake
      if (this.containsCommonMistakes(txt)) {
        this.addressError.push('Common mistakes error')
      }

      if (this.allowedAddressEnding(txt)) {
        this.addressError.push('Not allowed address ending error')
      }

      //common company phrase
      if (txt.length > 150) {
        this.addressError.push('Maximum length error')
      }
      this.addressErrorCount = this.addressError.length

      return txt
    },
    showError: function() {
      //console.log(this.commonAddressError.toString())
      
      this.snackbartext = this.commonAddressError.toString()
      this.snackbar =  true
    },
    showOtherDialog: function (item) {
      this.currentItem = item
      this.dialogTitle = 'Assign Certificate Number'
      this.dialogMessage = 'This action will assign number number to this client. Do you wish to continue?'
      this.dialog = true
    },
    closeOtherDialog: function () {
      this.dialogTitle = ''
      this.dialogMessage = ''
      this.dialog = false
    },
    assignNumber: function (item) {
      const postData = this.prePostData

      this.overlay = true
      this.dialogTitle = ''
      this.dialogMessage = ''
      this.dialog = false

      postData.id = this.currentItem.id
      postData.membership_id = this.currentItem.membership_id
      postData.lOB = this.currentItem.lOB

      if (this.currentItem.lOB === 'Distributor') {
        postData.distributor_category = this.currentItem.distributor_category
      }

      const url = httpServ.getCertificateUrl('/admin/assignNumber')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        if (result.status === 200) {
          this.getTableData()
        } 
      })
      this.overlay = false
    },
   
    rowStatus: function(item) {
      if (item.certificate_number !== null) {
        return 'license'
      }  else {
        if (item.operational_state !== null) {
          return 'state'
        }  else {
          return 'none'
        }
      }
    },
    isLicenseInitialize: function(item) {
      if (item.operational_state === null) {
        return true
      }  else {
        return false
      }
    },
    hasLicense: function(item) {

      if (item.certificate_number !== null) {
        return true
      }  else {
        return false
      }
    },
    vetDetails: function(item) {
      item.status = 'old'
      this.$router.push({ name: 'remitaInvoice', params:  {
        obj: { item }
      } })
    },
    moveTo: function(item) {
      item.status = 'old'
      this.$router.push({ name: 'remitaInvoice', params:  {
        obj: { item }
      } })
    },

    /////////////////
    /////////////////
    viewInvoice: function(item) {
      item.status = 'old'
      this.$router.push({ name: 'remitaInvoice', params:  {
        obj: { item }
      } })
    },

    isLicenseInitialize33334: function(item) {
      if (item.operational_state === null) {
        return true
      }  else {
        return false
      }
    },
    isInvoiceViewOK: function(item) {

      if (item.payment_status === 1) {
        return true
      }  else {
        return false
      }
    },
    verifyOldRRR: function() {
      const url = httpServ.getPaymentUrl('/payment/remita/createInvoice')
      const resp = httpServ.postFetchWithToken(
        url,
        postData,
        this.memberData.jwt
      )

      resp.then((result) => {
        if (result.status === 200) {
          item.RRR = result.data.RRR
          item.transactionId = result.data.transaction_id
          item.status = 'new'
          this.snackbartext = 'Your invoice have generated successfully',
          this.snackbar = true
          //const { id } = item

          this.$router.push({ name: 'remitaInvoice', params:  {
            obj: { item }
          } })
        } else {
          this.snackbartext = 'Error: ' + result.message + '! You need to try again'
          this.snackbar = true
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
